import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { isActiveMenu } from '../utils';
import * as S from './styles';
const TextSubMenu = ({ item }) => {
    const { href, title, callback } = item;
    const mainHref = isEmpty(href) ? undefined : href;
    return (React.createElement(S.CustomLink, { href: mainHref, underline: "none", "$isActive": isActiveMenu(href), onClick: callback ? callback : undefined },
        React.createElement(S.Wrapper, null,
            React.createElement("span", { className: "title" }, title))));
};
export default TextSubMenu;
//# sourceMappingURL=index.js.map